import React from 'react';
import {
  Navigate,
  RouteObject
} from 'react-router-dom';

import { AuthLayout } from './AuthLayout';
import { LoginActivity } from './LoginActivity/LoginActivity';
import { RegisterActivity } from './RegisterActivity/RegisterActivity';



export const root: RouteObject = {
  path: 'auth',
  element: (<AuthLayout />),
  children: [
    {
      path: 'login',
      element: <LoginActivity />,
      children: []
    },
    {
      path: 'register',
      element: <RegisterActivity />,
      children: []
    },
    {
      path: 'register/:inviteCode',
      element: <RegisterActivity />,
      children: []
    }
  ]
};
